import {
    IonGrid,
    IonRow,
    IonCol,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonListHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonText,
    useIonViewWillEnter,
    isPlatform,
    IonFooter,
    IonCard,
    IonCardHeader,
    IonCardContent,
    IonRouterLink,
    IonPopover,
  } from '@ionic/react';
import { build, informationCircleSharp, giftSharp, downloadOutline, syncCircleSharp, mail, library, caretDown, people, person, bookSharp } from 'ionicons/icons';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import './HomePage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import { SelectActiveReadingPlanRecord, SelectLastVersion, SelectNextUnreadURL, SelectReadingPlans, SelectScheduledURL, UpdateActivePlanByIdAsync } from '../../store/BibleStudySlice';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import IPrayerSettings from '../../interfaces/IPrayerSettings';
import NoSleepContext from '../../components/NoSleepContext/NoSleepContext';
import PrayerSettingsService from '../../services/PrayerSettingsService';
import { DefaultPrayerSettings } from '../../data/DefaultPrayerSettings';
import { SelectLoginStatus } from '../../store/UserSlice';
import { UserRouteInfo, UserRouteKeys } from '../../routes/UserRoutes';
import CreatePrayerIcon from '../../assets/images/homeCards-createPrayer.svg';
import ManagePrayersIcon from '../../assets/images/homeCards-managePrayers.svg';
import GroupLoginIcon from '../../assets/images/homeCards-login.svg';
import JoinGroupIcon from '../../assets/images/homeCards-joinGroup.svg';
import FellowshipIcon from '../../assets/images/homeCards-fellowship.svg';
import PrayNowIcon from '../../assets/images/homeCards-prayNow.svg';
import CreateGroupIcon from '../../assets/images/homeCards-createGroup.svg';
import TodaysBibleStudyIcon from '../../assets/images/homeCards-todaysBibleStudy.svg';
import NextUnreadDayIcon from '../../assets/images/homeCards-nextUnreadDay.svg';
import ContinueReadingIcon from '../../assets/images/homeCards-continueReading.svg';
import SetupPlanIcon from '../../assets/images/homeCards-setupPlan.svg';
import { InsomniaOriginal } from '@awesome-cordova-plugins/insomnia';
import NoSleep from 'nosleep.js';
import AppInfo from '../../data/AppInfo';
import HomePageBanner from '../../components/HomePageBanner/HomePageBanner';
import { ReadingPlanCodes } from '../../data/ReadingPlans';
import SelectReadingPlanPopUp from '../../components/SelectReadingPlanPopUp/SelectReadingPlanPopUp';
import IReadingPlanRecord from '../../interfaces/IReadingPlanRecord';
import { SelectGroupIds } from '../../store/FellowshipSlice';
import HomeBannerService from '../../services/HomeBannerService';
import IHomeBanner, { HomeBannerDefault } from '../../interfaces/IHomeBanner';

  const Tab1: React.FC<IRouteInfo> = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [prayerSettings, setPrayerSettings] = useState<IPrayerSettings | undefined>(undefined);
    const [homeBannerInfo, setHomeBannerInfo] = useState<IHomeBanner>(HomeBannerDefault);
    const noSleep = useContext(NoSleepContext);
    const LoggedIn = useSelector(SelectLoginStatus);
    const userGroupIds = useSelector(SelectGroupIds);
    const nextUnreadSessionURL = useSelector(SelectNextUnreadURL);
    const scheduledSessionURL = useSelector(SelectScheduledURL);
    const ActiveReadingPlanRecord = useSelector(SelectActiveReadingPlanRecord);
    const [appInstalled, setAppInstalled] = useState(true);
    const [showPlanMenu, setShowPlanMenu] = useState(false);
    const [planMenuEvent, setPlanMenuEvent] = useState<Event | undefined>(undefined);
    const readingPlans = useSelector(SelectReadingPlans); 
    const lastSelectedVersion = useSelector(SelectLastVersion);
    //const [ActivePlan, setActivePlan] = useState('NO PLAN');

    console.log('hybrid', isPlatform('hybrid'), appInstalled);

    useIonViewWillEnter(() => {
      if(!isPlatform('hybrid')) {
        // making typescript happy
        const windowNavigator: any = window.navigator;
        // check to see if app installed on ios or android
        const isInstalled = windowNavigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
        setAppInstalled(isInstalled);
        console.log('hybrid', isPlatform('hybrid'), isInstalled);
      }

      loadPrayerSettings();
      loadHomeBannerInfo();
    });

    useEffect(() => {
      // Load info for reading plan options when groups are found
      if(userGroupIds.length) {
        UpdateActivePlanByIdAsync(dispatch, userGroupIds);
      }
    }, [userGroupIds])

    const loadPrayerSettings = () => {
      PrayerSettingsService.getPrayerSettings().then(response => {
        if(response.Success && response.Data) {
          setPrayerSettings(response.Data!)
        }
        else {
          setPrayerSettings(DefaultPrayerSettings);
        }
      });
    };

    const loadHomeBannerInfo = () => {
      HomeBannerService.getHomeBannerInfo().then(response => {
        if(response.Success && response.Data) {
          setHomeBannerInfo(response.Data!);
        } else {
          setHomeBannerInfo(HomeBannerDefault);
        }
      });
    };

    const enableNoSleep = () => {
      if(isPlatform('hybrid')) {
        const awake = noSleep as InsomniaOriginal;
        awake?.keepAwake();
      } else if (!isPlatform('ios')) {
        const awake = noSleep as NoSleep;
        awake?.enable();
      } 
    }

    const navigateToSetupPlanLink = (record?: IReadingPlanRecord) => {
      return record && record.readingPlanCode !== ReadingPlanCodes.bible ? 
          `${AppRouteInfo[AppRouteKeys.ReadingScheduler].rootPath}/${record?.readingPlanCode}/${ActiveReadingPlanRecord?.id}` :
          `${AppRouteInfo[AppRouteKeys.BiblePlanSelector].rootPath}/`;
    }

    const getBibleReadingLinks = (currentPlan: string) => {
      const planCode = currentPlan ? currentPlan : ReadingPlanCodes.bible;

      switch(planCode) {
        case ReadingPlanCodes.bible:
          return <IonGrid>
                  <IonRow className="home-link-card">
                    <IonCol className="active-plan-link-left" >
                      <IonRouterLink routerLink={`${AppRouteInfo[AppRouteKeys.BiblePlanSelector].rootPath}/`}>
                        <img alt="" src={SetupPlanIcon} />
                      </IonRouterLink>
                    </IonCol>
                    <IonCol className="active-plan-link-right">
                      <IonRouterLink routerLink={
                        nextUnreadSessionURL ? nextUnreadSessionURL : `${AppRouteInfo[AppRouteKeys.Bible].rootPath}/${ReadingPlanCodes.bible}/1/${lastSelectedVersion}`}>
                        <img alt="" src={ContinueReadingIcon} />
                      </IonRouterLink>
                    </IonCol>
                  </IonRow>
                </IonGrid>
           default: 
            return <IonGrid>
                    <IonRow className="home-link-card">
                      <IonCol className="active-plan-link-left">
                        <IonRouterLink routerLink={scheduledSessionURL}>
                          <img alt="" src={TodaysBibleStudyIcon} />
                        </IonRouterLink>
                      </IonCol>
                      <IonCol className="active-plan-link-right">
                        <IonRouterLink routerLink={nextUnreadSessionURL}>
                          <img alt="" src={NextUnreadDayIcon} />
                        </IonRouterLink>
                      </IonCol>
                    </IonRow>
                  </IonGrid>
      }
    }
    const getButtonLink = (icon: string, path: string) => {
      return <IonCard mode="md">
                <IonCardHeader>
                  <IonRouterLink routerLink={path}>
                    <img alt="" src={icon} />
                  </IonRouterLink>
                </IonCardHeader>
              </IonCard>
    }

    const getButtonLinks = () => {
      let output = <span></span>;

      const prayNow = <IonCard mode="md">
                        <IonCardHeader>
                          <img alt="" className="cursor-pointer" src={PrayNowIcon} onClick={() => {
                              if(!!prayerSettings?.showSettings) {
                                history.push(AppRouteInfo[AppRouteKeys.PrayerSessionSettings].path, {direction: 'forward'});
                              } else {
                                enableNoSleep();
                                history.push(AppRouteInfo[AppRouteKeys.PrayNow].path, {direction: 'forward'});
                              }
                            }} />
                        </IonCardHeader>
                      </IonCard>

      if(LoggedIn) {
        output =
          <Fragment>
            <IonRow className="home-link-card">
              <IonCol sizeXs="6" sizeMd="4" >
                {prayNow}
              </IonCol>
              <IonCol sizeXs="6" sizeMd="4">
                {getButtonLink(FellowshipIcon, AppRouteInfo[AppRouteKeys.Fellowship].path)}
              </IonCol>
              <IonCol sizeXs="6" sizeMd="4">
                {getButtonLink(ManagePrayersIcon, AppRouteInfo[AppRouteKeys.MyPrayers].path)}
              </IonCol>
              <IonCol sizeXs="6" className="ion-hide-md-up">
                {getButtonLink(CreatePrayerIcon, AppRouteInfo[AppRouteKeys.PrayerUpdate].path.replace(':id', 'new'))}
              </IonCol>
            </IonRow>
          </Fragment> 
      } else {
        output =
          <Fragment>
            <IonRow className="home-link-card">
              <IonCol sizeXs="6" sizeMd="4">
                {getButtonLink(GroupLoginIcon, AppRouteInfo[AppRouteKeys.Fellowship].path)}
              </IonCol>
              <IonCol sizeXs="6" sizeMd="4">
                {getButtonLink(CreatePrayerIcon, AppRouteInfo[AppRouteKeys.PrayerUpdate].path.replace(':id', 'new'))}
              </IonCol>
              <IonCol sizeXs="6" sizeMd="4">
                {getButtonLink(JoinGroupIcon, UserRouteInfo[UserRouteKeys.FellowshipGroupJoin].path.replace('/:loadJoinCode?', ''))}
              </IonCol>
              <IonCol sizeXs="6" sizeMd="4">
                {getButtonLink(CreateGroupIcon, UserRouteInfo[UserRouteKeys.FellowshipGroupCreate].path)}
              </IonCol>
              <IonCol sizeXs="6" sizeMd="4"> 
                {prayNow}
              </IonCol>
              <IonCol sizeXs="6" sizeMd="4">
                {getButtonLink(ManagePrayersIcon, AppRouteInfo[AppRouteKeys.MyPrayers].path)}
              </IonCol>
            </IonRow>
          </Fragment> 
      }

      return output;
    }

    return (
      <IonPage>
        <IonHeader mode="ios">
          <IonToolbar color={props.themeColorName}>
            <IonTitle className="header-tile">{props.title}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent className="home-page-content">
          <div className="home-page-card">
            <IonGrid fixed={true}>
              <IonRow className="ion-text-center">
                <IonCol>
                  <HomePageBanner info={homeBannerInfo}></HomePageBanner>
                </IonCol>
              </IonRow>
              <IonRow className="ion-text-center">
                <IonCol>
                  <IonCard mode="md" className="home-bible-reading-links">
                    <IonCardHeader className="bible-reading-plan-selector">
                      <IonGrid className="reading-plan-header-grid">
                        <IonRow>
                          <IonCol sizeXs="12" sizeSm="6" className="reading-plan-header">
                            <IonIcon icon={library}/><IonText>Active Bible Plan:</IonText>
                          </IonCol>
                          <IonCol sizeXs="12"  sizeSm="6">
                            <div className="active-plan" onClick={e => { 
                                setShowPlanMenu(true); 
                                setPlanMenuEvent(e.nativeEvent);
                            }}>
                              <div className="active-plan-left"></div>
                              <div className="active-plan-middle">
                                { ActiveReadingPlanRecord?.readingPlanCode === ReadingPlanCodes.bible ?
                                    <IonIcon slot="start" icon={bookSharp} className="bible-version-arrow"></IonIcon> :
                                  ActiveReadingPlanRecord?.groupId ? 
                                    <IonIcon slot="start" icon={people} className="bible-version-arrow"></IonIcon> :
                                    <IonIcon slot="start" icon={person} className="bible-version-arrow"></IonIcon>
                                }
                                {ActiveReadingPlanRecord && ActiveReadingPlanRecord.name ? 
                                  ActiveReadingPlanRecord.name : ActiveReadingPlanRecord ?
                                  'UNTITLED PLAN' : 'READ THE BIBLE'}
                              </div>
                              <div className="active-plan-right">
                                <IonIcon icon={caretDown} color="primary" />
                              </div>
                            </div>
                          </IonCol>
                        </IonRow>
                      </IonGrid>
                    </IonCardHeader>
                    <IonCardContent>
                      { getBibleReadingLinks(ActiveReadingPlanRecord?.readingPlanCode) }
                    </IonCardContent>
                  </IonCard>
                </IonCol>
              </IonRow>
              { getButtonLinks() }
            </IonGrid>
          </div>

          <IonList mode="ios" className="home-menu-options-container">
            <IonListHeader>
              <IonLabel color="secondary">MORE OPTIONS:</IonLabel>
            </IonListHeader>
            <IonItem routerLink={AppRouteInfo[AppRouteKeys.InstallAppInstructions].path} className={appInstalled ? 'hidden' : ''}>
              <IonIcon slot="start" color="tertiary" icon={downloadOutline} />
              <IonLabel color="tertiary" className="menu-label">Install App Instructions</IonLabel>
            </IonItem>
            {ActiveReadingPlanRecord && ActiveReadingPlanRecord?.readingPlanCode !== ReadingPlanCodes.bible && 
            <IonItem routerLink={navigateToSetupPlanLink(ActiveReadingPlanRecord)}>
              <IonIcon slot="start" color="primary" icon={build} />
              <IonLabel color="primary" className="menu-label">
                 Update Bible Reading Plan
              </IonLabel>
            </IonItem> }
            <IonItem routerLink={`${AppRouteInfo[AppRouteKeys.BiblePlanSelector].rootPath}/`}>
              <IonIcon slot="start" color="primary" icon={build} />
              <IonLabel color="primary" className="menu-label">
                Setup New Bible Plan</IonLabel>
            </IonItem>
            <IonItem routerLink={`${AppRouteInfo[AppRouteKeys.BiblePlanManager].path}`}>
              <IonIcon slot="start" color="primary" icon={build} />
              <IonLabel color="primary" className="menu-label">
                Manage Bible Plans</IonLabel>
            </IonItem>
            <IonItem routerLink={UserRouteInfo[UserRouteKeys.SyncUserData].path} >
              <IonIcon slot="start" color="medium" icon={syncCircleSharp} />
              <IonLabel color="medium" className="menu-label">Sync Prayers & Plan</IonLabel>
            </IonItem>
            <IonItem href="https://biblestudytogether.com/join/" rel="noreferrer" target="_blank">
              <IonIcon slot="start" color="medium" icon={informationCircleSharp} />
              <IonLabel color="medium" className="menu-label">About BST</IonLabel>
            </IonItem>
            <IonItem href="https://biblestudytogether.com/contact-us-app-help/" rel="noreferrer" target="_blank">
              <IonIcon slot="start" color="medium" icon={mail} />
              <IonLabel color="medium" className="menu-label">Report A Problem</IonLabel>
            </IonItem>
            <IonItem href="https://createdisciples.com/donate/" rel="noreferrer" target="_blank">
              <IonIcon slot="start" color="medium" icon={giftSharp} />
              <IonLabel color="medium" className="menu-label">Donate</IonLabel>
            </IonItem>
            <IonItem href="https://biblestudytogether.com/privacy-policy-create-disciples-and-bible-study-together/" rel="noreferrer" target="_blank">
              <IonIcon slot="start" color="medium" icon={informationCircleSharp} />
              <IonLabel color="medium" className="menu-label">Privacy Policy</IonLabel>
            </IonItem>
            <IonItem href="https://biblestudytogether.com/app-terms-of-use/" rel="noreferrer" target="_blank">
              <IonIcon slot="start" color="medium" icon={informationCircleSharp} />
              <IonLabel color="medium" className="menu-label">Terms of Use</IonLabel>
            </IonItem>
            <IonItem routerLink={AppRouteInfo[AppRouteKeys.BibleTranslationNotice].path} >
              <IonIcon slot="start" color="medium" icon={informationCircleSharp} />
              <IonLabel color="medium" className="menu-label">Translation Use</IonLabel>
            </IonItem>
          </IonList>
          <IonText color="medium" className="ministry-footer-statement"
            onClick={() => history.push(AppRouteInfo[AppRouteKeys.AppInformation].path, {direction: 'forward'})}>
            A Ministry of Create Disciples Inc.<br />
            version {AppInfo.version}
          </IonText>
          <IonPopover
                className="bible-reading-header-plan-menu"
                mode="md"
                dismissOnSelect={true}
                isOpen={showPlanMenu}
                event={planMenuEvent}
                onDidDismiss={() => {
                    setShowPlanMenu(false); 
                    setPlanMenuEvent(undefined);
                }}
            ><SelectReadingPlanPopUp 
              readingPlanRecord={ActiveReadingPlanRecord} 
              readingPlans={readingPlans} 
              navigateOnClick={false}
              userGroupIds={userGroupIds}/></IonPopover>
        </IonContent>
        <IonFooter>
          <div className="home-ios-safe-zone"></div>
        </IonFooter>
      </IonPage>
    );
  };

  export default Tab1;
